import styled from 'styled-components'
import { color } from 'utils/functions/colors'

export const Container = styled.div`
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: ${color('lightGray')};
`
